import * as React from 'react'
import { Text, View } from 'react-native'
import styled from '@theme/styled-components'

import Picker from '@components/picker/Picker'

const TEST_DATA = [
  { label: 'Item 1', value: 1 },
  { label: 'Item 2', value: 2 },
  { label: 'Item 3', value: 3 },
  { label: 'Item 4', value: 4 },
  { label: 'Item 5', value: 5 },
  { label: 'Item 6', value: 6 },
  { label: 'Item 7', value: 7 },
  { label: 'Item 8', value: 8 },
]

const PickersSection = () => {
  const [value, setValue] = React.useState<PickerOption>()
  const [value2, setValue2] = React.useState<PickerOption>()

  return (
    <Section>
      <SectionTitle>Pickers</SectionTitle>
      <Container zIndex={0}>
        <Picker options={TEST_DATA} title="Title" value={value} onChange={setValue} placeholder="Placeholder" />
      </Container>
      <Container zIndex={-1}>
        <Picker
          options={TEST_DATA}
          title="Title"
          isClearable
          onClear={() => setValue(undefined)}
          value={value}
          onChange={setValue}
          hint="Hint"
          placeholder="Placeholder"
        />
      </Container>
      <Container zIndex={-2}>
        <Picker
          title="Title"
          options={TEST_DATA.slice(0, 3)}
          value={value2}
          onChange={setValue2}
          hint="Hint"
          error="Error"
          placeholder="Placeholder"
        />
      </Container>
      <Container zIndex={-3}>
        <Picker
          options={TEST_DATA}
          title="Title"
          value={value}
          onChange={setValue}
          disabled
          placeholder="Placeholder"
        />
      </Container>
    </Section>
  )
}

export default PickersSection

const Section = styled(View)`
  padding: 24px;
  border-color: ${(props) => props.theme.colors.disable};
  border-bottom-width: 1px;
  border-style: solid;
`
const SectionTitle = styled(Text)`
  margin-bottom: 15px;
  text-decoration: underline;
  ${(props) => props.theme.fonts.LargeTitle};
`
const Container = styled(View)<{ zIndex: number }>`
  z-index: ${(props) => props.zIndex};
  margin-bottom: 12px;
`
